import { getClient, PollingMode, LogLevel, createConsoleLogger, User } from 'configcat-js-ssr';

import request from '../../libs/request';

export default {
  initialStoreAndTheme: async (overrideHeaders) => {
    const data = await request(`api/v1/store/domain/`).get({ overrideHeaders });

    return data;
  },

  fetchFeatureFlags: async ({ sdkKey, userId }) => {
    try {
      if (!sdkKey) return null;
      const configCatClient = getClient(sdkKey, PollingMode.LazyLoad, {
        cacheTimeToLiveSeconds: 5 * 60,
        logger: createConsoleLogger(LogLevel.Off),
      });
      const userObject = new User(userId);
      return await configCatClient.getAllValuesAsync(userObject);
    } catch (error) {
      return null;
    }
  },

  cleanStoreCache: (service, siteId) => {
    return request(`api/v1/${siteId}/manager/cache/${service}`).delete();
  },

  updateFeather: (siteId) => {
    return request(`api/v1/${siteId}/store/domain/`).put();
  },

  getLegacyRoutes: (siteId) => {
    return request(`api/v1/${siteId}/legacyRoutes`).get();
  },

  saveLegacyRoute: (body, siteId) => {
    return request(`api/v1/${siteId}/legacyRoutes`).post({ body });
  },

  saveCampaign: (body, siteId) => {
    return request(`api/v1/${siteId}/acesso`).post({ body });
  },

  saveErrorLog: (body, siteId) => {
    return request(`api/v1/${siteId}/errors/request`).post({ body });
  },

  seoRequest: (page, siteId) => request(`api/v1/${siteId}/slug/url/${page}`).get(),

  getCategories: (siteId) => request(`api/v1/${siteId}/pagina/publication/desktop/feather`).get(),
};
